import { useIonRouter } from '@ionic/react';
import LoadingPage from '../../LoadingPage';
import { useLocationRedirector } from './hook.useLocationRedirector';
import { useEffect } from 'react';

export const UserCatalogLocationRedirector = () => {
  const link = useLocationRedirector({ allowSet: true });

  const router = useIonRouter();

  useEffect(() => {
    if (link && router.routeInfo.pathname === '/catalog') {
      router.push(link, 'none', 'pop');
    }
  }, [link]);

  if (!link) return <LoadingPage />;

  return null;
};
